package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_05_23_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-05-23")
@Composable
public fun Log_2026_05_23(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "The Five Tabaxi Brothers",
        ogTitle = "The Five Tabaxi Brothers",
        date = LocalDate(2_026, 5, 23),
        aiHint = "Image, title, and description compare the similarities between events in the campaign with the legend of the five Chinese brothers as depicted in the children's book.",
        ogDescription = "Once upon a time, there were Five Tabaxi Brothers, and they all looked exactly alike. The First Tabaxi Brother could swallow the sea and collect all the “Feeshes.” The Second Tabaxi Brother was immune to venom, even from a Giant Scorpion. The Third Tabaxi Brother had an iron neck and could not be beheaded, even by a Vorpal Sword.",
        ogImage = "images/TheFiveTabaxiBrothers_Preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-31", dateString = "Shimmer 31", cardImageSrc = "images/TheFiveTabaxiBrothers_Details.webp", width = 1_200, height = 630)
        Log_2026_05_23_Day_1()
    }
}
